module.exports = __webpack_public_path__ + "shared/static_img/logo_main.d314327c.png";